Vendd.Scripts.load(function () {

    /**
     * @param {String} text 
     * @returns {Array<String>}
     */
    function ParseMenuCodes(text)
    {
        if(_.isEmpty(text))
        {
            return [];
        }

        var result = text.split(",");
        
        result = _.filter(result, function(x)  { return !_.isEmpty(x); });
        result = _.filter(result, function(x)  { return x.trim(x); });
        result = _.filter(result, function(x)  { return !_.isEmpty(x); });

        return result;
    };

    var flatternModel = function(model) {

        if(!_.isArray(model))
        {
            return [];
        }

        var result = [];

        _.each(model, function(x) {

            var node = _.extend({}, x);

            if(_.isArray(node.MenuItems))
            {
                delete node.MenuItems;
            }

            result.push(node);

        });

        _.each(model, function(x) {

            if(_.isArray(x.MenuItems))
            {
                result = _.union(result, flatternModel(x.MenuItems));
            }

        });

        result = _.filter(result, function(x) { return _.isString(x.MenuCode) && !_.isEmpty(x.MenuCode); });
        result = _.filter(result, function(x) { return _.isString(x.Url) && !_.isEmpty(x.Url); });

        return result;
    };

    var fixUrls = function(model) { 

        if(!_.isArray(model))
        {
            return [];
        }

        _.each(_.extend([], model), function(x) { x.Url = Vendd.api.path('admin', `app/frame/${x.Url}`) });

        return model;
    };

    var parseApmType = function(text) {

        const allowedTypes = ['grid', 'item', 'siteReplication'];

        if(!_.isString(text) || _.isEmpty(text)) {

            return 'item';

        }

        var result = _.find(allowedTypes, function(x) { return x ===  text});

        return _.isString(result) ? result : 'item';

    };

    var blueBorders = function (model) {

        var self = this;

        self.model = model;
        self.template = `
<div class="js-change-inline-admin-box {{#if sticky}}always-on{{/if}}">
    <a class="iframe icon icon-pencil js-inline-admin-setting" href="{{url}}"></a>
</div> `;
    };

    blueBorders.prototype.init = function () {

        var self = this;

        var items = [];

        _.each($('*[data-inline-admin-item-id]'), function(elem) {

            var x = $(elem);

            var itemId = parseInt(x.data('inline-admin-item-id'), 10);

            if(isNaN(itemId)) {

                return;

            }
                
            items.push({
                id: itemId,
                type: parseApmType(x.data('inline-admin-apm-type')),
                element: x,
                sticky: x.is('*[data-inline-admin-always-on]')
            });

        });

        _.each($('*[data-inline-admin-item-code]'), function(elem) {

            var x = $(elem);

            var itemCode = x.data('inline-admin-item-code');

            if(!_.isString(itemCode) || _.isEmpty(itemCode)) {

                return;
                
            }

            items.push({
                code: itemCode,
                type: parseApmType(x.data('inline-admin-apm-type')),
                element: x,
                sticky: x.is('*[data-inline-admin-always-on]')
            });

        });

        if(_.isEmpty(items)) {

            return Q.promise(function(resolve, reject) {  resolve(); });

        }

        var request = _.map(items, function(x) 
        { 
            if(_.isNumber(x.id)) {

                return { ItemId: x.id, AdminPanelModeType: x.type }

            } 
            
            if (_.isString(x.code) && !_.isEmpty(x.code)) {

                return { ItemCode: x.code, AdminPanelModeType: x.type };

            }

            return null;
            
        });

        request = _.filter(request, function(x) { return _.isObject(x); });

        return Vendd.api.call(Vendd.api.path('admin', '/api/BlueBorders/Index'), request, {
            language: LhApp.Context.Language
        })
            .then(function(response) { self.itemData = _.isArray(response) && !_.isEmpty(response) ? response : []; });
        
    };

    blueBorders.prototype.build = function () {

        var self = this;

        var items = [];

        var menuItemsFlatterned = flatternModel(self.model.MenuItems);
        menuItemsFlatterned = fixUrls(menuItemsFlatterned);

        _.each($('*[data-inline-admin-menu-code]'), function(elem) {

            var x = $(elem);

            var menuCodes = ParseMenuCodes(x.data('inline-admin-menu-code'));

            var menuItem = _.find(menuItemsFlatterned, function(x) { return _.some(menuCodes, function(menuCode) { return x.MenuCode === menuCode }); });

            if(!_.isObject(menuItem))
            {
                return;
            }

            items.push({
                //id: itemId,
                element: x,
                url: menuItem.Url
            });

        });

        var itemData = fixUrls(self.itemData);

        _.each($('*[data-inline-admin-item-id]'), function(elem) {

            var x = $(elem);

            var itemId = parseInt(x.data('inline-admin-item-id'), 10);

            if(isNaN(itemId))
            {
                return;
            }

            var result = _.find(itemData, function(x) { return x.Id === itemId });
            
            if(!_.isObject(result) || !_.isString(result.Url) || _.isEmpty(result.Url)) {

                return;

            }

            items.push({
                id: result.Id,
                code: result.Code,
                element: x,
                url: result.Url
            });

        });
        
        _.each($('*[data-inline-admin-item-code]'), function(elem) {

            var x = $(elem);

            var itemCode = x.data('inline-admin-item-code');

            if(!_.isString(itemCode) || _.isEmpty(itemCode)) {

                return;
                
            }

            var result = _.find(itemData, function(x) { return x.Code === itemCode });
            
            if(!_.isObject(result) || !_.isString(result.Url) || _.isEmpty(result.Url)) {

                return;

            }

            items.push({
                id: result.Id,
                code: result.Code,
                element: x,
                sticky: x.is('*[data-inline-admin-always-on]'),
                url: result.Url
            });

        });

        self.items = items;

    };

    blueBorders.prototype.render = function () {

        var self = this;
        
        var template = Handlebars.compile(self.template);

        _.each(self.items, function(x) {

            var html = template(x);

            x.element.addClass('inline-admin-anchor');
            x.element.addClass('active');
            
            x.element.append(html);

        });

    };

    blueBorders.prototype.bind = function () {

        var self = this;

        _.each($('*[data-inline-admin-menu-code], *[data-inline-admin-item-id], *[data-inline-admin-item-code]'), function(elem) {

            var x = $(elem);

            $(".js-inline-admin-setting", x).fancybox({ type: 'iframe', baseClass: "inline-admin-popup", toolbar: false, smallBtn: true });
            
        });
    };

    var Vendd = window.Vendd || {};

    Vendd.blueBorders = blueBorders;

});